import { render, staticRenderFns } from "./ModalHomologar.vue?vue&type=template&id=18ce6edf"
import script from "./ModalHomologar.vue?vue&type=script&lang=ts"
export * from "./ModalHomologar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports